import { IMPRESSION_ACTIONS, SCREEN_NAME } from "@payment-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/analytics";

export function closingTImerImpressionEvent(impressionEvent: AnalyticsContextValue["impressionEvent"]): void {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CLOSING_TIMER,
    });
}

export const closingTImerHalfCardImpressionEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT_HALF_CARD,
        action: IMPRESSION_ACTIONS.IMPRESSION_CLOSING_TIMER_HALF_CARD,
    });
};
